import React from 'react';
import BaseList from 'components/lists/BaseList';
import { useAccessLog } from 'hooks/logs';

function ListEquipmentExemplary(props) {
  useAccessLog('Acesso ao cadastro de exemplares');
  const { match } = props;
  return (
    <BaseList
      columns={[
        { value: row => row.name, label: 'Nome', sort: 'name' },
      ]}
      genericSearchFields={[
        { label: 'Nome', name: 'name' },
      ]}
      basePath="equipment-exemplary"
      title="Lista de Exemplares"
      addButtonText="Cadastrar Exemplar"
      addUrl={`${match.path}/novo`}
    />
  );
}

export default ListEquipmentExemplary;
